<div class="preview-dialog">
    <div class="preview-dialog__header">
        <div class="preview-dialog__title">{{ this.translateService.getTranslatedLabel('label.marketing.tools.zone.preview') + ': ' + data.title }}</div>
        <button type="button" class="preview-dialog__close" [mat-dialog-close]="true">✕</button>
    </div>

    <div class="preview-dialog__body">
        <ng-container *ngIf="!imageError; else fallback">
            <img
                    class="preview-dialog__image"
                    [src]="data.previewUrl"
                    [alt]="this.translateService.getTranslatedLabel('label.marketing.tools.zone.preview') + ': ' + data.title"
                    (error)="imageError = true"
            />
        </ng-container>

        <ng-template #fallback>
            <div class="preview-dialog__fallback">
                <div class="preview-dialog__fallback-icon" [ngClass]="data.defaultThumbnailClass"></div>
                <div class="preview-dialog__fallback-text">Preview is not available</div>
            </div>
        </ng-template>
    </div>
</div>
